import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import store from "./store"
import Sensors from '@/util/Sensors'
import '@/publicResource/flexible/index.js'
import { Toast, Progress, Slider } from 'vant'
import VConsole from 'vconsole'
import {AppCourier, Bridge, WEB_PLATFORM} from "mt-app-bridge/index";
import wx from 'weixin-js-sdk'
import { isInWxMP } from "@/util";
if (isInWxMP()) {
  window.wx = wx
}
// axios使用了promise，默认babel不会兼容node_module依赖的库，所以增加promise兼容
require('es6-promise').polyfill()
Vue.use(Toast).use(Progress).use(Slider)
if (process.env.VUE_APP_ENV_MICRO !== 'production') {
  new VConsole()
}

// 初始化埋点
const channelFromQuery = window.location.href.match(/[?&]f=([^&/#]*)/)
const channelFrom = channelFromQuery && channelFromQuery[1]

const campaignBrandQuery = window.location.href.match(/[?&]campaignBrand=([^&/#]*)/)
// 兼容 brand 参数
const brandQuery = window.location.href.match(/[?&]brand=([^&/#]*)/)
const brand = (campaignBrandQuery && campaignBrandQuery[1])|| (brandQuery && brandQuery[1])

const sensor = new Sensors({ channel: channelFrom || '0', brand: brand})

// 重制埋点匿名ID
const distinctIDQuery = window.location.href.match(/[?&]distinctID=([^&/#]*)/)
const distinctID = distinctIDQuery && distinctIDQuery[1]
Boolean(distinctID) && sensor.identify(distinctID)

// 收集 $pageview 全埋点
sensor.autoTrackSinglePage()

Vue.prototype.$sensors = sensor

Bridge.init(WEB_PLATFORM.APPOINTMENT, new AppCourier())

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
